/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "SoldiBackofficeRestApi",
            "endpoint": "https://4rs3r301q0.execute-api.us-east-1.amazonaws.com/bancarprod",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:c7f71580-7f30-4fd8-9b81-e4beb6111809",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_Zk7veXlzn",
    "aws_user_pools_web_client_id": "17hh0umo7vs51ps4hc2l86uvck",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "productbucket23030-bancarprod",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
